export default "__VITE_ASSET__15HcqDSN__"